<div class="k-custom-notification">
  <div class="k-widget k-notification k-notification-info">
      <kendo-icon [name]="'information'"></kendo-icon>
      <div class="k-notification-content">{{ 'circ_template_notification' | i18n }}</div>
  </div>
</div>


<circ-loader [isLoading]="saving">
  <form class="k-form" [formGroup]="form">
    <fieldset class="k-form-fieldset">
      <legend class="k-form-legend">{{ 'circ_template_legend' | i18n }}</legend>
      <kendo-formfield showHint="initial" showErrors="initial">
        <kendo-label [for]="title" [text]=" 'circ_new_label_title' | i18n "></kendo-label>
        <input kendoTextBox formControlName="title" #title />
        <kendo-formhint>{{ 'circ_template_formhint_title' | i18n }}</kendo-formhint>
      </kendo-formfield>
      <kendo-formfield showHint="initial" showErrors="initial">
        <kendo-label [for]="circulationTitle" [text]=" 'circ_template_label_circulationTitle' | i18n "></kendo-label>
        <input kendoTextBox formControlName="circulationTitle" #circulationTitle />
        <kendo-formhint>{{ 'circ_template_formhint_circulationTitle' | i18n }}</kendo-formhint>
      </kendo-formfield>
      <kendo-formfield [showErrors]="'initial'">
        <kendo-label [for]="demand" [text]="'circ_new_label_demand' | i18n"></kendo-label>
        <textarea kendoTextArea [formControlName]="'demand'" #demand></textarea>
        <kendo-formhint>{{ 'circ_template_formhint_demand' | i18n }}</kendo-formhint>
      </kendo-formfield>
      <div class="k-form-buttons">
        <ece-btn-primary (click)="save()" [text]=" 'circ_new_button_save' | i18n "></ece-btn-primary>
        <ece-btn (click)="abort()" [text]=" 'circ_new_button_abort' | i18n "></ece-btn>
      </div>
    </fieldset>
  </form>
</circ-loader>
